import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { PageError } from "@/features/auth/components/PageError";
import { usePageState } from "@/hooks/usePageState";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { MarketplaceOrderImportPage } from "@/features/marketplace/admin/pages/MarketplaceOrderImportPage";

function MarketplaceOrderImportRoute() {
  const { t } = useTranslation();
  useDocumentTitle(t("marketplace.admin.import.title", "Import orders"));

  const { isLoading, error } = usePageState("marketplace.admin");
  if (isLoading) return null;
  if (error) return <PageError is403={error instanceof PageAccessError} />;
  return <MarketplaceOrderImportPage />;
}

export const Route = createFileRoute("/_authenticated/marketplace/import")({
  beforeLoad: () => assertPagePermission("marketplace.admin"),
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("marketplace.admin"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: MarketplaceOrderImportRoute,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});
